import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

export function BooleanForm() {
    const { isFormDisabled, form } = useFieldFormContext();


    return (
        <div className="flex flex-col gap-2">
            <FormField
                name="field_min_label"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Label for false value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='text'
                                maxLength={60}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_max_label"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Label for true value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='text'
                                maxLength={60}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
}